import { Call } from '@twilio/voice-sdk';

/** The `callType` markus stamps on a discharge escalation's `<Client>` leg. */
export const DISCHARGE_CALL_TYPE = 'discharge_call';

/**
 * The `callType` markus stamps on a warm-transfer leg.
 *
 * Compared with `===`, and markus pins the same spelling on its side, so a rename needs both repos.
 */
export const WARM_TRANSFER_CALL_TYPE = 'warm_transfer';

export interface IncomingCallData {
  call: Call;
  callerNumber: string;
  callerName?: string;
  /**
   * True when markus labelled this leg a discharge escalation.
   *
   * Read from the TwiML `callType` parameter rather than inferred from the caller's number: on an
   * agent transfer `From` is the originating clinic's outbound caller ID, one hardcoded number per
   * clinic, so it says which clinic called and never what the call was for.
   */
  isPostDischargeCall?: boolean;
  /**
   * True when markus labelled this leg a warm transfer — a clinic handing a patient to whoever on
   * its care team picks up first.
   *
   * Read from the same `callType` parameter, for the same reason: the only thing the browser could
   * otherwise infer from is `From`, and on a warm transfer that is a SIP URI on our own domain. It
   * says the call came through the transfer address, never which clinic sent it there or why.
   */
  isWarmTransfer?: boolean;
  /** The clinic the warm transfer came from, when markus knew it. Not PHI. */
  clinicName?: string;
  /**
   * Set when the microphone is known to be unavailable as the call rings. The call can still be
   * answered: dropping a clinical transfer is worse than answering it with a microphone that is down.
   */
  microphoneUnavailable?: 'permission-denied' | 'no-device';
}
export interface CallSession {
  sessionId: string;
  parentCallSid: string;
  direction: 'inbound' | 'outbound-dial';
  originalFrom: string;
  originalTo: string;
  callLegs: {
    [callSid: string]: {
      callSid: string;
      parentCallSid: string;
      direction: 'inbound' | 'outbound-dial';
      from: string;
      to: string;
      status: string;
    };
  };
}
